<main class="page">
  <mat-card class="card" appearance="outlined">
    <img
      class="imt-logo imt-logo--landing"
      src="/imt_fi_logo_koralli.png"
      alt=""
      aria-hidden="true"
    />
    <p class="eyebrow">IMT feedback</p>
    <h1>Survey link required</h1>
    <p class="lead">
      Please open your survey from the email link so we can connect feedback to the correct trip.
    </p>
  </mat-card>
</main>
